import {
	apiConf,
	sendRequest
} from '../config'

/**
 * 获取网站信息总揽
 */
export const getWebSiteOverview = (param) => {
	return sendRequest(apiConf.webSiteApi.getWebSiteOverview)
}
/**
 * 获取网站列表
 */
export const getWebListInfo = (param) => {
	return sendRequest(apiConf.webSiteApi.getWebListInfo, param)
}
/**
 * 获取网站列表
 */
export const getStoreSelectOne = (param) => {
	return sendRequest(apiConf.webSiteApi.getStoreSelectOne, param)
}
/**
 * 获取交易详情
 */
export const getShopDetail = (param) => {
	return sendRequest(apiConf.webSiteApi.getShopDetail, param, {
		headers: {
			'Content-Type': 'application/x-www-form-urlencoded'
		}
	})
}
/**
 * 获取交易流水
 */
export const getTradeExportURL = (param) => {
	return sendRequest(apiConf.webSiteApi.getTradeExportURL, param)
}
/**
 * 获取待入账金额
 */
export const getPreInboundData = (param) => {
	return sendRequest(apiConf.webSiteApi.getPreInboundData, param)
}
/**
 * 获取待入账金额导出地址
 */
export const getPreInboundExportURL = (param) => {
	return sendRequest(apiConf.webSiteApi.getPreInboundExportURL, param)
}

/**
 * 获取保证金明细
 */
export const getDepositData = (param) => {
	return sendRequest(apiConf.webSiteApi.getDepositData, param)
}

/**
 * 获取保证金明细导出
 */
export const getDepositExportURL = (param) => {
	return sendRequest(apiConf.webSiteApi.getDepositExportURL, param)
}

/**
 *  网站管理账户余额
 */
export const getAccountBalance = (param) => {
	return sendRequest(apiConf.webSiteApi.getAccountBalance, param)
}

/**
 * 获取交易详情
 */
export const getTradeDetail = (param) => {
	return sendRequest(apiConf.webSiteApi.getTradeDetail, param)
}
/**
 * 取消交易
 */
export const cancleTrade = (param) => {
	return sendRequest(apiConf.webSiteApi.cancleTrade, param)
}

/**
 * 取消交易
 */
export const confirmTrade = (param) => {
	return sendRequest(apiConf.webSiteApi.confirmTrade, param)
}

/**
 * 取消交易
 */
export const returnTrade = (param) => {
	return sendRequest(apiConf.webSiteApi.returnTrade, param)
}

/**
 * 预授权请款
 */
export const fetchAuthCapture = (params) => {
	return sendRequest(['POST', '/merchant/acquirer/payment/capture'], params)
}

/**
 * 预授权撤销
 */
export const fetchAuthVoid = (params) => {
	return sendRequest(['POST', '/merchant/acquirer/payment/void'], params)
}

/**
 * 当前是否可以退款
 */
export const arrowRefund = (param) => {
	return sendRequest(apiConf.webSiteApi.arrowRefund, param)
}

/**
 * 提交记录列表
 */
export const getWithdrawRacdList = (param) => {
	return sendRequest(apiConf.webSiteApi.getWithdrawRacdList, param)
}
/**
 * 提交记录列表导出
 */
export const getWithdrawRacdExportURL = (param) => {
	return sendRequest(apiConf.webSiteApi.getWithdrawRacdExportURL, param)
}

/**
 * 获取提现网站
 */
export const getWithdrawWebsite = (param) => {
	return sendRequest(apiConf.webSiteApi.getWithdrawWebsite, param)
}

/**
 * 查看今日打款
 */
export const getTodayWithdraw = (param) => {
	return sendRequest(apiConf.webSiteApi.getTodayWithdraw, param)
}

/**
 * 提现
 */
export const doWithdraw = (param) => {
	return sendRequest(apiConf.webSiteApi.doWithdraw, param)
}
/**
 * 提现前校验是否需要触发短信
 */
export const validWithdrawVerify = (param) => {
	return sendRequest(apiConf.webSiteApi.withdrawVerify, param)
}
/**
 * 添加网站或者更新
 */
export const addmodAPI = (param) => {
	return sendRequest(apiConf.addWebApi.addmod, param)
}

// 网站申请表模版
export const getTemplate = (param) => {
	return sendRequest(apiConf.addWebApi.getTemplate, param)
}

// 获取交易状态和交易类型
export const getFundStatus = (param) => {
	return sendRequest(apiConf.webSiteApi.getTransactionFundStatus, param)
}

// 查询商户属性
export const getClientProperty = (param) => {
	return sendRequest(apiConf.webSiteApi.getClientProperty, param)
}

// 保存商户属性
export const saveClientProperty = (param) => {
	return sendRequest(apiConf.webSiteApi.saveClientProperty, param)
}

// 获取枚举
export const getDictionary = (param) => {
	return sendRequest(apiConf.webSiteApi.dictionary, param)
}

export const paymentReview = (param) => {
	return sendRequest(apiConf.webSiteApi.paymentReview, param)
}
// 退款
export const getArrowRefund = (param) => {
	return sendRequest(apiConf.webSiteApi.getArrowRefund, param)
}

/**
 *改变网站隐藏状态
 */
export const changeHideStatus = (params) => {
	return sendRequest(
		['POST', '/merchant/acquirer/store/changeHideStatus'],
		params
	)
}

/**
 *删除网站
 */
export const delStore = (params) => {
	return sendRequest(['POST', '/merchant/acquirer/store/delStore'], params)
}

/**
 * 绑定shopify授权
 */
export const toBindShopifyOauth = (params) => {
	return sendRequest(['POST', '/merchant/acquirer/platformApp/APP10010014/bindApp'], params)
}

/**
 * 解绑shopify授权
 */
export const unBindShopifyOauth = (accId) => {
	return sendRequest(['GET', `/merchant/acquirer/platformApp/APP10010014/unBindApp/${accId}`], {})
}

/**
 * wordPress 物流绑定
 */
export const merchantOauth = (params) => {
	return sendRequest(['POST', '/merchant/acquirer/store/merchantOauth'], params)
}

/**
 * wordPress 物流解绑
 */
export const deleteAuth = (params) => {
	return sendRequest(['POST', '/merchant/acquirer/store/deleteAuth'], params)
}

/**
 * 绑定shoplazza授权
 */
export const toBindShoplazzaOauth = (params) => {
	return sendRequest(['POST', '/merchant/acquirer/store/toBindShoplazzaOauth'], params)
}

/**
 * 获取 X-Man 渠道下银行列表
 */
export const getXManPayBank = (params) => {
	return sendRequest(['GET', '/merchant/acquirer/payment/getXManPayBank'])
}

/**
 * Marketplace - 子商户分页查询
 */
export const querySubMerchantPage = (params) => {
	return sendRequest(['POST', '/merchant/acquirer/subMerchant/querySubMerchantPage'], params)
}

/**
 * 获取 KBank 渠道下银行列表
 */
export const getKBanKPayBank = (params) => {
	return sendRequest(['GET', '/merchant/acquirer/payment/getThBankInfoList'])
}
